module.exports = __webpack_public_path__ + "2bfc70b2.png";